/**
 * Sanitizes raw user input for the TeamGroup `sortOrder` field down to a string
 * representing a positive integer, or an empty string when there is no valid value.
 *
 * - Strips everything that isn't a digit (so paste of "abc", "-1", "1.5" is neutralized).
 * - Strips leading zeros ("05" -> "5").
 * - A lone "0" collapses to "" (0 is not a valid sortOrder).
 */
export const sanitizeSortOrderInput = (raw: string): string => {
  const digitsOnly = raw.replace(/\D/g, '');
  const withoutLeadingZeros = digitsOnly.replace(/^0+(?=\d)/, '');

  if (withoutLeadingZeros === '0') {
    return '';
  }

  return withoutLeadingZeros;
};

/** Converts sanitized sortOrder input into the value expected by `UpsertTeamGroupInput`. */
export const parseSortOrderInput = (raw: string): number | null => {
  const sanitized = sanitizeSortOrderInput(raw);
  return sanitized === '' ? null : parseInt(sanitized, 10);
};
